// extracted by mini-css-extract-plugin
export var emptyState = "_4u-d";
export var statCard = "_4u-c";
export var table = "_4u-0";
export var tableCell = "_4u-4";
export var tableCellClickable = "_4u-5 _4u-4";
export var tableCellDefault = "_4u-6 _4u-4";
export var tableCellEmpty = "_4u-8";
export var tableCellWithValue = "_4u-7";
export var tableContainer = "_4u-e";
export var tableHeaderWeight = "_4u-1";
export var tableHeaderZone = "_4u-2";
export var tableRowHeader = "_4u-3";
export var viewModeButton = "_4u-9";
export var viewModeButtonActive = "_4u-a _4u-9";
export var viewModeButtonInactive = "_4u-b _4u-9";